import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/icon_warn@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-3052a8ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt_5"
}
const _hoisted_2 = { class: "flex-ter title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {"height":"16px","margin-right":"6px"}
}, null, -1))
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "flex-bwn-ter" }
const _hoisted_6 = {
  class: "flex-bwn-ter",
  style: {"margin-top":"10px"}
}

import { customer, settlement } from '@/api-ts'
import { t } from '@/plugins/i18n'
import { isJA, isSub, usePlat, useSource, useToken, useUser } from '@/store'
import { onMounted, ref, watch, reactive } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { rule, useMust } from '@/util/useRules'
import useForm from '@/util/useForm'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isOpen = ref(false)

const loading = ref(false)

const cancel = () => {
  isOpen.value = false
}

const [formRef, ok] = useForm(() => {
  const configList = []
  if (data.main) {
    configList.push({
      customerShopId: useUser().customerShopId,
      threshold: data.mainData.threshold
    })
  }
  if (data.sub && data.subList.length) {
    data.subList.forEach((v) => {
      configList.push({
        customerShopId: v.customerShopId,
        threshold: data.subData.threshold
      })
    })
  }
  console.log(configList)
  settlement['/wallet/remind/config/submit']({
    mainCustomerId: useUser().customerId,
    configList
  }).then(res => {
    ElMessage.success(t('保存成功'))
    isOpen.value = false
  })
})

const data = reactive({
  main: false,
  mainData: {
    threshold: 0
  },
  sub: false,
  subData: {
    threshold: 0
  },
  subList: [] as any[]
})

const rules = {
  mainData: rule(() => {
    if (data.main && data.mainData.threshold <= 0) {
      return t('请设置提醒金额')
    }
  }),
  subData: rule(() => {
    if (data.sub && data.subData.threshold <= 0) {
      return t('请设置提醒金额')
    }
  }),
  subList: rule(() => {
    if (data.sub && !data.subList.length) {
      return t('请添加子账号')
    }
  })
}

const options = ref<any[]>([])

watch(isOpen, async v => {
  if (v) {
    const config = await settlement['/wallet/remind/config/query']()

    data.main = false
    data.mainData = {
      threshold: 0
    }
    data.sub = false
    data.subData = {
      threshold: 0
    }
    data.subList = []
    console.log(config)
    config.data?.forEach(v => {
      if (v.accountType === 1) {
        data.main = true
        data.mainData = {
          threshold: v.threshold!
        }
      } else {
        data.sub = true
        data.subData = {
          threshold: v.threshold!
        }
        data.subList.push(v.customerShopId!)
      }
    })
    const shopdata = await customer['/getCanTransformList']()
    console.log(shopdata)
    options.value = shopdata.data!.filter((v) => {
      if (v.accountType === 2 && v.systemSource === useSource().systemSource) {
        return true
      }
    })
    data.subList = shopdata.data!.filter((v) => data.subList.includes(v.customerShopId))
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (!_unref(isSub)())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "text-blue cursor-pt",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true))
            }, _toDisplayString(_unref(t)('设置余额不足提醒')), 1))
          : _createCommentVNode("", true),
        _createVNode(CommonDialog, {
          visible: isOpen.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((isOpen).value = $event)),
          width: 400,
          className: "balance-lower-modal",
          onOk: _unref(ok),
          onCancel: cancel,
          footer: true,
          loading: loading.value
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_unref(t)('设置余额不足提醒')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                model: _unref(data),
                rules: rules,
                "label-position": "left",
                ref: (_value, _refs) => {
                  _refs['formRef'] = _value
                  _isRef(formRef) && (formRef.value = _value)
                }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('主账户余额不足提醒', { x: _unref(usePlat)() })), 1),
                    _createVNode(_component_el_switch, {
                      modelValue: _unref(data).main,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).main) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  (_unref(data).main)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: _unref(t)('低于该金额（元）时，通知我'),
                        prop: "mainData"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: _unref(data).mainData.threshold,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).mainData.threshold) = $event)),
                            controls: false,
                            min: 0,
                            max: 1000000,
                            precision: 2,
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('子账户余额不足提醒', { x: _unref(usePlat)() })), 1),
                    _createVNode(_component_el_switch, {
                      modelValue: _unref(data).sub,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(data).sub) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  (_unref(data).sub)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: _unref(t)('低于该金额（元）时，通知我'),
                        prop: "subData"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            modelValue: _unref(data).subData.threshold,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(data).subData.threshold) = $event)),
                            controls: false,
                            min: 0,
                            max: 1000000,
                            precision: 2,
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_unref(data).sub)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        label: _unref(t)('选择需提醒的子账号'),
                        prop: "subList"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(data).subList,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(data).subList) = $event)),
                            multiple: "",
                            style: {"width":"100%"},
                            "value-key": "customerShopName"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.loginName,
                                  label: item.customerShopName,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _: 1
        }, 8, ["visible", "onOk", "loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})